// extracted by mini-css-extract-plugin
export default {"tooltip":"ZB-z","arrow":"_B-z"};